import { render, staticRenderFns } from "./Flux360.vue?vue&type=template&id=3712a075&"
import script from "./Flux360.vue?vue&type=script&lang=js&"
export * from "./Flux360.vue?vue&type=script&lang=js&"
import style0 from "./Flux360.vue?vue&type=style&index=0&id=3712a075&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports